import numeral from 'numeral';
import { DateTime } from 'luxon';

export default function(value, format, lng) {
  console.log('format', value, format);
  if (format === 'lower') {
    return value.toLowerCase();
  } else if (format === 'thou') {
    return new Intl.NumberFormat().format(value);
  } else if (format === 'ordinal') {
    return numeral(value).format('0o');
  } else if (format === 'pct') {
    return numeral(value).format('0.0%');
  } else if (format === 'size') {
    if (value < 1024) {
      return numeral(value).format('0,0b');
    }
    return numeral(value).format('0,0.0b');
  } else if (format === 'sizekb') {
    if (value < 1024) {
      return numeral(value / 1000).format('0.0') + 'kB';
    }
    return numeral(value).format('0,0.0b');
  } else if (format === 'sizeB') {
    if (value < 1024) {
      return numeral(value).format('0,0ib');
    }
    return numeral(value).format('0,0.0ib');
  } else if (format === 'sizeB0') {
    return numeral(value).format('0,0ib');
  } else if ((format.substr(0, 4) === 'DATE') || (format.substr(0, 4) === 'TIME')) {
    const parts = format.split(/, */);
    if (!(value instanceof DateTime)) {
      const newValue = DateTime.fromISO(value);
      if (!newValue.isValid) {
        if (parts.length > 0) {
          if (parts[1] === 'blank') {
            value = '';
          } else {
            value = parts[1];
          }
        }
      } else {
        value = newValue;
      }
    }
    if (value instanceof DateTime) {
      let f = DateTime[parts[0]];
      if (parts[0].substr(-9) === 'TIME_HUGE') {
        f = Object.assign({}, f, { timeZoneName: 'short' });
      }
      return value.toLocaleString(f);
    } else {
      return value;
    }
  } else if (value instanceof DateTime) {
    return value.toISO();
  } else if (format === 'DOW') {
    return DateTime.local().set({ weekday: parseInt(value, 10) }).toFormat('EEEE');
  } else if (format.substr(0, 3) === 'pad') {
    return numeral(value).format('0'.repeat(format.substr(3)));
  } else if (format.substr(0, 8) === 'spacepad') {
    return value.toString().padStart(format.substr(8));
  } else if (format) {
    console.error('Unknown Interpolator', format, value, lng);
  }
  return value;
};
